/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';

class Card extends React.Component {
  render() {
    return <div className='dms-body'>
      {this.props.children}
    </div>
  }
};
export default Card;


// WEBPACK FOOTER //
// ./src/routes/card/index.js